import { render } from "./FormManterVinculoDepartamentoMedico.vue?vue&type=template&id=7f3d4911"
import script from "./FormManterVinculoDepartamentoMedico.vue?vue&type=script&lang=js"
export * from "./FormManterVinculoDepartamentoMedico.vue?vue&type=script&lang=js"

import "./FormManterVinculoDepartamentoMedico.vue?vue&type=style&index=0&id=7f3d4911&lang=css"
/* custom blocks */
import block0 from "./FormManterVinculoDepartamentoMedico.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__